import { createFileRoute } from '@tanstack/react-router';

import { PlanCoreCalcsTab, QueryBoundary } from '../../../../../components';

const Page = () => {
  const params = Route.useParams();

  return (
    <QueryBoundary>
      <PlanCoreCalcsTab planId={params.planId} />
    </QueryBoundary>
  );
};

export const Route = createFileRoute(
  '/organizations/$advisoryOrganizationId/plans/$planId/core-calcs'
)({
  component: Page
});
